import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

export type SubmitButtonProps = Pick<
    LoadingButtonProps,
    'color' | 'disabled' | 'children'
>;

export interface BasicDialogProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSubmit?: (...args: any[]) => void;
    open: boolean;
    onCancel?: () => void;
    onClose?: () => void;
    children?: React.ReactNode;
    title: string;
    submitButtonProps?: SubmitButtonProps;
    cancelButton?: string;
    processing?: boolean;
}

export function BasicDialog({
    open,
    onSubmit,
    onCancel,
    onClose,
    children,
    title,
    processing,
    submitButtonProps,
    cancelButton = 'Cancel',
}: BasicDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby={'form-dialog-dialog'}
            PaperProps={{
                sx: theme => ({
                    minWidth: theme.breakpoints.values.sm,
                }),
            }}
        >
            <DialogTitle id={'form-dialog-title'}>{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    {cancelButton}
                </Button>

                <LoadingButton
                    onClick={onSubmit}
                    color="primary"
                    type="submit"
                    variant="contained"
                    loading={processing}
                    {...submitButtonProps}
                >
                    {submitButtonProps?.children ?? 'Submit'}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

BasicDialog.Text = DialogContentText;
